<template>
  <v-menu
    ref="datePicker"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        :value="value"
        readonly
        :clearable="value && value != '' ? true : false"
        clear-icon="mdi-close-circle"
        @click:clear="$emit('input', '')"
        @click:append="menu = true"
        :error="!error || error == '' ? false : true"
        persistent-hint
        dense
        style="max-width: 160px"
        hide-details
        outlined
        :disabled="disabled"
        :label="label"
        :append-icon="!value ? 'mdi-calendar-range' : null"
        v-on="on"
        v-bind="attributesBinding"
        :autofocus="autofocus"
      ></v-text-field>
    </template>
    <v-date-picker
      :value="value"
      :min="min && min != '' ? min : null"
      :locale="locale"
      :max="max"
      no-title
      @change="onChangeDate($event)"
    ></v-date-picker>
  </v-menu>
</template>

<script>
export default {
  props: {
    value: String,
    locale: {
      type: String,
      default: "ja",
    },
    label: String,
    min: String,
    error: String,
    max: String,
    disabled: {
      type: Boolean,
      default: false,
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
  }, // Use "value" here to enable compatibility with v-model
  data() {
    return {
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      classList: "",
    };
  },
  methods: {
    onChangeDate(event) {
      this.menu = false;
      this.$emit("input", event);
    },
  },
  watch: {
    value: function (val) {
      console.log("val: ", val);
    },
  },
  mounted() {
    this.classList = this.$refs.datePicker.$el.classList;
  },
  computed: {
    attributesBinding() {
      var attr = {
        class: "",
      };
      for (let i = 0; i < this.classList.length; i++) {
        if (this.classList[i] !== "v-menu") {
          attr.class += " " + this.classList[i];
          console.log("this.classList[i]: ", this.classList[i]);
        }
      }
      return attr;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>